import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DemandSourceReferenceService extends BaseReferenceService {
  constructor() {
    super('DemandSourceReference');
  }
}
